var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 32,
    style: {
      fill: "#FFCB57"
    },
    width: 40,
    x: 22,
    y: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,9h34v2h2V6c0-2.757-2.243-5-5-5H6C3.243,1,1,3.243,1,6v45h2V9z M6,3h28c1.654,0,3,1.346,3,3v1H3    V6C3,4.346,4.346,3,6,3z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 10,
    x: 15,
    y: 57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,58c0,2.757,2.243,5,5,5h28c2.757,0,5-2.243,5-5v-5H1V58z M3,55h34v3c0,1.654-1.346,3-3,3H6    c-1.654,0-3-1.346-3-3V55z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,13H21v34h16v4h2v-4h24V13z M61,45H23V15h38V45z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 39,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 43,
    y: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,43h2v-4h2v4h2V33h14v10h2v-4h2v4h2v-4h2v-8h-6h-1h-1v-5h2c1.103,0,2-0.897,2-2v-3    c0-1.103-0.897-2-2-2h-2v-2H35v2h-2c-1.103,0-2,0.897-2,2v3c0,1.103,0.897,2,2,2h2v5h-1h-1h-6v8h2V43z M55,33v4h-4v-4H55z M51,21    v3h-2v-3H51z M33,24v-3h2v3H33z M37,19h10v12H37V19z M29,33h4v4h-4V33z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 34,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 17,
    y: 13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 34,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 13,
    y: 13
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres10);
export default __webpack_public_path__ + "static/media/AIres10.5b02745929b3e26757eb11ce9cadb9ed.svg";
export { ForwardRef as ReactComponent };